import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { SelectorDialogData } from '../selector-dialog/selector-dialog.component';
import { FormsModule } from '@angular/forms';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-checkbox-selector-dialog',
  templateUrl: './checkbox-selector-dialog.component.html',
  styleUrl: './checkbox-selector-dialog.component.css',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatCheckbox, MatDialogActions, MatButton, FormsModule],
})
export class CheckboxSelectorDialogComponent implements OnInit {
  dialogRef = inject<MatDialogRef<CheckboxSelectorDialogComponent>>(MatDialogRef);
  data = inject<SelectorDialogData>(MAT_DIALOG_DATA);

  selectedValues: any[] = [];

  ngOnInit(): void {
    if (this.data.initial_selected_values?.length) {
      this.selectedValues = [...this.data.initial_selected_values];
    }
  }

  toggleSelection(value: any): void {
    const index = this.selectedValues.indexOf(value);
    if (index >= 0) {
      this.selectedValues.splice(index, 1);
    } else {
      this.selectedValues.push(value);
    }
  }

  isSelected(value: any): boolean {
    return this.selectedValues.includes(value);
  }

  submit(): void {
    this.dialogRef.close(this.selectedValues);
  }

  close(): void {
    this.dialogRef.close();
  }
}
